import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import qcareApi from '../../api/qcareApi'
import { PDFScreen } from './PDFScreen';
import { Report, SingleReportResponse } from '../../interfaces/intakes.reports';
import { useCharts } from '../../hooks/useCharts';
import { Spinner } from '../ui/Spinner';
import { useNoIndex } from '../../hooks/useNoIndex';


export const ViewPdf = () => {

    useNoIndex();

    const [allData, setAllData] = useState<Report | null>(null)
    const { id } = useParams()

    const { charts, ready, DonutsRenderer } = useCharts(allData)

    useEffect(() => {
        async function fetchData() {
            const { data } = await qcareApi.get<SingleReportResponse>(`/report/${id}`)
            setAllData(data.singleReport)
        }
        fetchData()
    }, [id])

    return (
        <>
            {
                (allData) &&
                DonutsRenderer
            }
            {ready
                ?
                (allData) &&
                <PDFScreen allData={allData} charts={charts} />
                :
                <Spinner />
            }
        </>

    );
}
